import { LuSearch, LuX } from "react-icons/lu";
import {
  useProjectsListActions,
  useProjectsListSearchQuery,
} from "../../../core_stores/useProjectsListStore";

export default function SideMenuSearchField() {
  const searchQuery = useProjectsListSearchQuery();
  const { onSearchQueryChange } = useProjectsListActions();

  const handleClear = () => {
    onSearchQueryChange("");
  };

  return (
    <div className="relative">
      <input
        type="text"
        placeholder="Search projects..."
        value={searchQuery}
        className="w-full bg-[#C6C9D9] dark:bg-[#212528] 
          text-light-text dark:text-dark-text 
          placeholder-light-text dark:placeholder-dark-text 
          rounded-full py-2 pl-10 pr-10 
          focus:outline-none focus:ring-2 focus:ring-blue-500"
        onChange={(e) => onSearchQueryChange(e.target.value)}
      />
      <LuSearch
        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-light-text dark:text-dark-text"
        size={22}
      />
      {searchQuery && (
        <button
          onClick={handleClear}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 
            text-light-text dark:text-dark-text hover:text-gray-600 dark:hover:text-gray-400
            transition-colors duration-200"
        >
          <LuX size={18} />
        </button>
      )}
    </div>
  );
}
